class OrganaxNavigation extends HTMLElement {
  connectedCallback() {
    document.body.classList.add('organax-nav-enhanced');
    this.root = this.querySelector('.organax-nav__root');
    this.opener = this.root.querySelector(':scope > summary');
    this.drawer = this.querySelector('.organax-nav__drawer');
    this.branches = [...this.querySelectorAll('.organax-nav__branch')];
    this.categoryBranch = this.querySelector('.organax-nav__branch[data-nav-kind="categories"]') || this.querySelector('.organax-nav__branch[data-nav-kind="category"]');
    this.desktop = matchMedia('(min-width: 750px)');
    this.onViewportChange = () => this.closeWithoutFocus();
    this.desktop.addEventListener('change', this.onViewportChange);
    this.headerSection = this.closest('.section-header');
    this.lastScrollY = window.scrollY;
    this.onScroll = this.updateHeaderOnScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.updateHeaderOnScroll();

    this.opener.addEventListener('click', (event) => {
      if (!this.desktop.matches) return;
      if (this.root.open && this.hoverCategoryOpen) {
        event.preventDefault();
        this.cancelHoverClose();
        this.hoverCategoryOpen = false;
        this.setActiveHeaderTrigger(null);
        this.branches.forEach((branch) => { branch.open = false; });
        this.root.dataset.navStage = 'primary';
        return;
      }
      if (!this.root.open) this.root.dataset.navStage = 'primary';
    });
    this.root.addEventListener('toggle', () => {
      if (this.root.open) document.querySelector('organax-search')?.close();
      this.opener.setAttribute('aria-expanded', String(this.root.open));
      this.opener.setAttribute('aria-label', this.root.open ? 'Close menu' : this.opener.dataset.closedLabel);
      document.body.classList.toggle('organax-nav-open', this.root.open);
      this.updateHeaderOnScroll();
      if (!this.root.open) {
        this.cancelHoverClose();
        this.hoverCategoryOpen = false;
        this.setActiveHeaderTrigger(null);
        this.root.dataset.navStage = 'primary';
        this.branches.forEach((branch) => { branch.open = false; });
      }
    });

    this.branches.forEach((branch) => {
      const summary = branch.querySelector(':scope > summary');
      branch.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(branch.open));
        if (branch.open) this.branches.filter((other) => other !== branch).forEach((other) => { other.open = false; });
      });
      summary.addEventListener('click', (event) => {
        if (!this.desktop.matches) return;
        event.preventDefault();
        this.showBranch(branch);
      });
      branch.querySelector('.organax-nav__back')?.addEventListener('click', () => {
        branch.open = false;
        summary.focus();
      });
      branch.querySelectorAll('[data-nav-target]').forEach((target) => {
        const activate = () => this.activatePreview(branch, target);
        target.addEventListener('pointerenter', (event) => {
          clearTimeout(this.previewIntentTimer);
          if (this.desktop.matches && event.pointerType !== 'touch') {
            this.previewIntentTimer = setTimeout(() => {
              if (this.root.open && this.desktop.matches) activate();
            }, 70);
          }
        });
        target.addEventListener('pointerleave', () => clearTimeout(this.previewIntentTimer));
        target.addEventListener('focus', () => {
          if (this.desktop.matches) activate();
        });
        if (target.tagName === 'SUMMARY') {
          target.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            if (this.desktop.matches) { event.preventDefault(); activate(); }
          });
        }
      });
      branch.querySelectorAll('.organax-nav__category').forEach((category) => {
        const categorySummary = category.querySelector(':scope > summary');
        categorySummary.addEventListener('click', (event) => {
          if (!this.desktop.matches || event.target.closest('a')) return;
          event.preventDefault();
          const opening = !category.open;
          branch.querySelectorAll('.organax-nav__category').forEach((other) => { other.open = opening && other === category; });
          branch.querySelectorAll('.organax-nav__category-preview, [data-nav-target]').forEach((item) => item.classList.remove('is-active'));
          this.root.dataset.navStage = 'secondary';
        });
        category.addEventListener('toggle', () => {
          categorySummary.setAttribute('aria-expanded', String(category.open));
          if (!this.desktop.matches && category.open) {
            branch.querySelectorAll('.organax-nav__category').forEach((other) => { if (other !== category) other.open = false; });
          }
        });
      });
    });

    this.topTriggers = [...document.querySelectorAll('.organax-site .header__inline-menu .organax-nav__top-trigger')];
    this.onResize = () => this.updateMenuReach();
    window.addEventListener('resize', this.onResize, { passive: true });
    this.updateMenuReach();
    this.categoryTrigger = this.topTriggers.find((item) => /^categories?$/.test(item.dataset.organaxMenu));
    this.topTriggers.forEach((trigger) => {
      const branch = this.branches.find((item) => item.dataset.navKind === trigger.dataset.organaxMenu);
      const isShop = trigger.dataset.organaxMenu === 'shop-root';
      if (!branch && !isShop) return;
      const open = (hover) => isShop ? this.showShop(trigger, hover) : this.showTopBranch(branch, trigger, hover);
      trigger.addEventListener('pointerenter', (event) => {
        if (this.desktop.matches && event.pointerType !== 'touch') open(true);
      });
      trigger.addEventListener('pointerleave', (event) => {
        if (!this.drawer.contains(event.relatedTarget)) this.queueHoverClose(350);
      });
      trigger.addEventListener('click', (event) => {
        if (!this.desktop.matches) return;
        event.preventDefault();
        if (isShop && this.root.open && this.activeHeaderTrigger === trigger && !this.hoverCategoryOpen) {
          this.closeWithoutFocus();
          trigger.focus();
          return;
        }
        open(isShop ? false : event.detail > 0 && event.pointerType !== 'touch');
      });
      trigger.addEventListener('keydown', (event) => {
        if (!this.desktop.matches) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open(false);
          const scope = branch?.querySelector('.organax-nav__panel') || this.drawer;
          [...scope.querySelectorAll('a[href], button, summary')].find((item) => item.getClientRects().length)?.focus();
        } else if (event.key === 'Escape' && this.root.open) {
          event.preventDefault();
          this.closeWithoutFocus();
          trigger.focus();
        }
      });
    });
    document.querySelectorAll('.organax-site .header__inline-menu a.header__menu-item').forEach((item) => {
      item.addEventListener('pointerenter', () => this.queueHoverClose());
    });
    this.drawer.addEventListener('pointerenter', () => this.cancelHoverClose());
    this.drawer.addEventListener('pointerleave', (event) => {
      if (!this.desktop.matches || !this.root.open) return;
      if (this.activeHeaderTrigger?.contains(event.relatedTarget) || this.opener.contains(event.relatedTarget)) return;
      this.closeWithoutFocus();
    });
    this.querySelector('.organax-nav__backdrop')?.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (event) => this.onKeyDown(event));
  }

  disconnectedCallback() {
    clearTimeout(this.previewIntentTimer);
    this.cancelHoverClose();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.desktop.removeEventListener('change', this.onViewportChange);
    document.body.classList.remove('organax-nav-open', 'organax-nav-enhanced');
    this.headerSection?.classList.remove('organax-header-search-only');
  }

  updateMenuReach() {
    if (!this.desktop.matches) return;
    const menu = document.querySelector('.organax-site .header__inline-menu');
    if (!menu?.getClientRects().length) return;
    const right = menu.getBoundingClientRect().right;
    this.root.style.setProperty('--organax-nav-reach', `${Math.ceil(right - 20)}px`);
  }

  updateHeaderOnScroll() {
    if (!this.headerSection) return;
    const scrollY = window.scrollY;
    const delta = scrollY - this.lastScrollY;
    const pastHeader = scrollY > 120;
    this.headerSection.classList.toggle('organax-header-sticky', pastHeader);
    if (!pastHeader || this.root.open || delta < -2) this.headerSection.classList.remove('organax-header-hidden');
    else if (delta > 2) this.headerSection.classList.add('organax-header-hidden');
    this.headerSection.classList.toggle('organax-header-search-only', this.headerSection.classList.contains('organax-header-hidden'));
    if (Math.abs(delta) > 2 || !pastHeader) this.lastScrollY = scrollY;
  }

  showBranch(branch) {
    this.cancelHoverClose();
    if (this.hoverCategoryOpen && branch.open) return;
    this.root.open = true;
    this.branches.forEach((other) => { other.open = other === branch; });
    branch.querySelectorAll('.organax-nav__category-preview').forEach((preview) => preview.classList.remove('is-active'));
    branch.querySelectorAll('[data-nav-target]').forEach((target) => target.classList.remove('is-active'));
    this.setActiveHeaderTrigger(this.topTriggers?.find((trigger) => trigger.dataset.organaxMenu === branch.dataset.navKind));
    this.root.dataset.navStage = 'secondary';
  }

  setActiveHeaderTrigger(trigger) {
    this.topTriggers?.forEach((item) => {
      const active = item === trigger;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-expanded', String(active));
    });
    this.activeHeaderTrigger = trigger || null;
  }

  activatePreview(branch, target) {
    if (!this.desktop.matches) return;
    const parentCategory = target.closest('.organax-nav__category');
    if (parentCategory && target.dataset.navTarget === parentCategory.querySelector(':scope > summary')?.dataset.navTarget) return;
    const key = target.dataset.navTarget;
    const preview = [...branch.querySelectorAll('.organax-nav__category-preview')].find((item) => item.dataset.navPreview === key);
    if (!preview) return;
    const category = target.closest('.organax-nav__category');
    if (target.tagName === 'SUMMARY' && category) {
      branch.querySelectorAll('.organax-nav__category').forEach((other) => { other.open = other === category; });
    }
    branch.querySelectorAll('.organax-nav__category-preview').forEach((item) => item.classList.toggle('is-active', item === preview));
    branch.querySelectorAll('[data-nav-target]').forEach((item) => item.classList.toggle('is-active', item === target));
    this.root.dataset.navStage = 'products';
    this.loadPreview(preview);
  }

  async loadPreview(preview) {
    // Support existing fragments during an incremental theme update.
    const storedProducts = preview.querySelector('template[data-nav-products]');
    if (storedProducts) storedProducts.replaceWith(storedProducts.content);
    const slot = preview.querySelector('[data-nav-products-url]');
    if (slot && !slot.dataset.loading && !slot.dataset.loaded) {
      slot.dataset.loading = 'true';
      slot.setAttribute('aria-busy', 'true');
      this.previewRequests ||= new Map();
      const url = new URL(slot.dataset.navProductsUrl, window.location.origin);
      url.searchParams.set('section_id', 'organax-2026-menu-products');
      try {
        if (url.origin !== window.location.origin) throw new Error('Menu collection must be local');
        let request = this.previewRequests.get(url.href);
        if (!request) {
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), 8000);
          request = fetch(url.href, { credentials: 'same-origin', signal: controller.signal })
            .then(response => {
              if (!response.ok) throw new Error(`Menu products: ${response.status}`);
              return response.text();
            })
            .then(html => {
              const parsed = new DOMParser().parseFromString(html, 'text/html');
              const products = parsed.querySelector('.organax-nav__products');
              if (!products) throw new Error('Menu products missing');
              return products.outerHTML;
            })
            .finally(() => clearTimeout(timer));
          this.previewRequests.set(url.href, request);
          while (this.previewRequests.size > 24) this.previewRequests.delete(this.previewRequests.keys().next().value);
          request.catch(() => {
            if (this.previewRequests.get(url.href) === request) this.previewRequests.delete(url.href);
          });
        }
        const html = await request;
        // A late response must not mount hidden forms/images or reopen a menu.
        if (!this.isConnected || !this.desktop.matches || !this.root.open || !preview.classList.contains('is-active')) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        slot.replaceChildren(parsed.querySelector('.organax-nav__products'));
        slot.dataset.loaded = 'true';
      } catch {
        const fallback = slot.querySelector('[role="status"]');
        if (fallback) fallback.textContent = 'Products could not load. Use View collection to keep shopping.';
      } finally {
        delete slot.dataset.loading;
        slot.setAttribute('aria-busy', 'false');
      }
    }
    const query = preview.dataset.navQuery;
    if (!query || preview.dataset.navLoading) return;
    preview.dataset.navLoading = 'true';
    const fallback = preview.querySelector('.organax-nav__preview-empty');
    const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last', section_id: 'organax-2026-nav-suggest' });
    try {
      const response = await fetch(`/search/suggest?${params}`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Menu suggestions: ${response.status}`);
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const products = document.querySelector('.organax-nav__products');
      if (products?.children.length) fallback?.replaceWith(products);
      else if (fallback) fallback.textContent = `No ${query} products found. View all results.`;
    } catch {
      if (fallback) fallback.textContent = `Explore ${query} products in search.`;
    }
    delete preview.dataset.navQuery;
  }

  showTopBranch(branch, trigger, openedByHover = false) {
    if (!branch) return;
    this.cancelHoverClose();
    this.updateMenuReach();
    this.hoverCategoryOpen = openedByHover;
    this.root.open = true;
    this.branches.forEach((item) => { item.open = item === branch; });
    this.setActiveHeaderTrigger(trigger);
    branch.querySelectorAll('.organax-nav__category-preview, [data-nav-target]').forEach((item) => item.classList.remove('is-active'));
    this.root.dataset.navStage = 'secondary';
  }

  showShop(trigger, openedByHover = false) {
    this.cancelHoverClose();
    this.hoverCategoryOpen = openedByHover;
    this.root.open = true;
    this.branches.forEach((branch) => { branch.open = false; });
    this.root.dataset.navStage = 'primary';
    this.setActiveHeaderTrigger(trigger);
  }

  showCategories(openedByHover = false) {
    this.showTopBranch(this.categoryBranch, this.categoryTrigger, openedByHover);
  }

  close() {
    this.closeWithoutFocus();
    const focusTarget = this.opener.getClientRects().length ? this.opener : this.activeHeaderTrigger || this.topTriggers?.find(item => item.dataset.organaxMenu === 'shop-root');
    focusTarget?.focus();
  }

  closeWithoutFocus() {
    this.cancelHoverClose();
    this.hoverCategoryOpen = false;
    this.root.open = false;
  }

  cancelHoverClose() {
    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = null;
  }

  queueHoverClose(delay = 0) {
    if (!this.hoverCategoryOpen || !this.desktop.matches) return;
    this.cancelHoverClose();
    this.hoverCloseTimer = setTimeout(() => this.dismissHoverCategory(), delay);
  }

  dismissHoverCategory() {
    this.cancelHoverClose();
    this.hoverCategoryOpen = false;
    this.root.open = false;
  }

  onKeyDown(event) {
    if (!this.root.open) return;
    if (event.key === 'Tab' && this.hoverCategoryOpen) {
      this.cancelHoverClose();
      this.hoverCategoryOpen = false;
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      if (this.hoverCategoryOpen) {
        const trigger = this.activeHeaderTrigger;
        this.dismissHoverCategory();
        trigger?.focus();
        return;
      }
      const category = event.target.closest('.organax-nav__category[open]');
      const branch = event.target.closest('.organax-nav__branch[open]');
      if (category && !this.desktop.matches) {
        category.open = false;
        category.querySelector(':scope > summary')?.focus();
      } else if (branch) {
        branch.open = false;
        this.root.dataset.navStage = 'primary';
        branch.querySelector(':scope > summary')?.focus();
      } else this.close();
      return;
    }
    if (event.key !== 'Tab') return;
    const openPanel = this.querySelector('.organax-nav__branch[open] .organax-nav__panel');
    const scope = openPanel && !this.desktop.matches ? openPanel : this.drawer;
    const focusable = [...scope.querySelectorAll('a[href], button:not([tabindex="-1"]), summary')].filter((element) => {
      const closed = element.closest('details:not([open])');
      return element.getClientRects().length && (!closed || element.tagName === 'SUMMARY' && element.parentElement === closed);
    });
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}

if (!customElements.get('organax-navigation')) customElements.define('organax-navigation', OrganaxNavigation);
